import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, switchMap, tap } from 'rxjs';

import { ProfessionalService } from 'src/app/shared/services/professional.service';
import {
  deleteProfessional,
  editProfessional,
  editProfessionalError,
  editProfessionalSuccess,
  loadProfessional,
  loadProfessionalSuccess,
  saveProfessional,
  saveProfessionalError,
  saveProfessionalSuccess,
} from './professional.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';
import { loadProfessionalServiceByIdProfessional } from '../professional-service/professional-service.actions';
import { editProfessionSuccess } from '../profession/profession.actions';
import { IProfessional } from 'src/app/shared/interfaces/professional/iprofessional';

@Injectable()
export class ProfessionalEffects {
  constructor(
    private service: ProfessionalService,
    private action$: Actions,
    private notify: NotifyService
  ) {}

  loadProfessional$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadProfessional),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadProfessionalSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );

  saveProfessional$ = createEffect(() =>
    this.action$.pipe(
      ofType(saveProfessional),
      concatMap(({ professional }) =>
        this.service.save(professional).pipe(
          tap(() => this.notify.saveSuccess()),
          //tap((res) => {console.log(res)}),
          //tap(() => this.notify.saveSuccess()),p
          switchMap((res) => [saveProfessionalSuccess({ professional: res })]),
          catchError((error) => {
             
            if (error?.error.id) {
              this.notify.emitWarn('Cadastro Realizado com sucesso, mas existem pendencias, conferir dashboard')
          } else {
              this.notify.emitError(error?.error?.error)
          }

            return of(saveProfessionalError({ error: error?.error }));
          })
        )
      )
    )
  );

  editProfessional$ = createEffect(() =>
    this.action$.pipe(
      ofType(editProfessional),
      concatMap(({ professional, id }) =>
        this.service.edit(professional, id).pipe(
          tap(() => this.notify.editSuccess()),
          switchMap((res: IProfessional) => [ editProfessionalSuccess({professional: res})]),
          catchError((error : any) => {
            
            if (error?.error.id) {
              this.notify.emitWarn('Cadastro Realizado com sucesso, mas existem pendencias, conferir dashboard')
          } else {
              this.notify.emitError(error?.error?.error)
          }
            
            return of(editProfessionalError(error.error['hydra:description']));
          })
        )
      )
    )
  );

  deleteProfessional$ = createEffect(() =>
    this.action$.pipe(
      ofType(deleteProfessional),
      concatMap(({ id }) =>
        this.service.delete(id).pipe(
          tap(() => this.notify.deleteSuccess()),
          map((res) => loadProfessional()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );
}
